export const getApiHost = () => {
    // GAM ads (with creative config) - PAU, SPLA, SDU, MXR, Cart Asset, etc.
    if (window && window?.config && window.config?.host) {
        return window.config.host;
    }
    return 'https://live.polaris.me';
};
